import PropTypes from 'prop-types';
import React, { Component } from 'react';
import Link from 'react-router/lib/Link';
import RosettaFormattedMessage from '../common/rosetta_formatted_message';
import { ChevronLeft, ChevronRight } from '../common/fa_icons';
import { nextAndPrevArchivesPaths } from '../../utils/date';
import {partial} from 'lodash';
import { getRelativePath } from '../../utils/url';

const toDayLink = (className, chevron, path, message) => (
  <div className={`day-link ${className}`}>
    <Link to={path}>
      <span>{message}</span>
      {chevron}
    </Link>
  </div>
);

export default class ArchivesDayNav extends Component {
  prevLink = (path) => (
    <RosettaFormattedMessage parentFilename={__filename}
      id="prev"
      description="Link to the previous day in the archives nav"
      defaultMessage="Previous Day"
      children={partial(toDayLink, 'prev', <ChevronLeft />, path)}
    />
  );

  nextLink = (path) => (
    <RosettaFormattedMessage parentFilename={__filename}
      id="next"
      description="Link to the next day in the archives nav"
      defaultMessage="Next Day"
      children={partial(toDayLink, 'next', <ChevronRight />, path)}
    />
  );

  render() {
    const { timestamp } = this.props;
    const { next, prev } = nextAndPrevArchivesPaths(
      this.context.edition_data.id, timestamp
    );
    return (
      <div id="archives-day-nav" className="module">
        {prev && this.prevLink(getRelativePath(prev, this.context.edition_data))}
        {next && this.nextLink(getRelativePath(next, this.context.edition_data))}
      </div>
    );
  }
}

ArchivesDayNav.propTypes = {
  timestamp: PropTypes.number.isRequired
};

ArchivesDayNav.contextTypes = {
  edition_data: PropTypes.object
};
